import { EventQuery, TimelineEvent } from "~/types/event";
import { EventClient } from "./eventClient";
import { TransformedTimelineData } from "../deviceFetch/timeline";
import { EventsWorkerOptions } from "./eventsWorker";
import { apiFetch } from "..";
import { EventEmitter } from "~/store/event";

export const DeviceTimelineClientEvents = new EventEmitter<{
  'worker:data': [objectID: string, workerID: string, events: TransformedTimelineData];
  'worker:error': [objectID: string, workerID: string, error: Error];
}>();

export class DeviceTimelineClient {
  private instance?: EventClient;

  constructor() {
    this.instance = new EventClient();
  }

  async initialize(query: EventQuery, token: string, updateCallback: <T = TransformedTimelineData>(id: string, workerID: string, data: T) => void, options: EventsWorkerOptions = {}) {
    await this.instance?.initialize(query, token, async (id, workerID, data) => {
      console.log("🌐⚙️: timeline worker data", id, workerID, data);

      const transformedData = await apiFetch("transformTimelineGraphData", data as TimelineEvent[], await this.instance?.getLatestQuery() ?? query);
      updateCallback(id, workerID, transformedData);
      DeviceTimelineClientEvents.emit('worker:data', id, workerID, transformedData);
    }, {
      ...options,
      name: `timeline`,
    });
  }


  terminate() {
    this.instance?.terminate();
  }

  getWorkerID() {
    return this.instance?.getWorkerID();
  }
}